import format from 'date-fns/format'
import add from 'date-fns/add'
import sub from 'date-fns/sub'
import parseISO from 'date-fns/parseISO'
import { DEFAULT_DATE_FORMAT, API_DATE_FORMAT } from 'constants/date'

export const dateToBR = (date = '') => {
  if (!date) return ''

  return format(new Date(date), DEFAULT_DATE_FORMAT)
}

export const todayString = () => {
  const today = new Date()

  return format(today, API_DATE_FORMAT)
}

export const addDays = (date, days) => (
  add(date, { days })
)

export const subDays = (date, days) => (
  sub(date, { days })
)

export const parseToDate = (dateStr) => (
  parseISO(dateStr)
)
